import Api from '@/utils/Api';

export const deleteBill = async (billId, data) => {
  return await Api.delete(`bills/${billId}`, data);
};

export const updateBillPayment = async (billId, data) => {
  return await Api.put(`bills/${billId}`, data);
};
